import { useQuery } from "@tanstack/react-query";
import { Disclosure } from "../../../components/Disclosure";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import "./LanzarCiclos.scss";
import { Constantes } from "../../../ts/constantes";
import { ModalInformacionPedido } from "./components/ModalInfoPedido";
import { ModalConfirmarLanzar } from "./components/ModalConfirmarLanzar";
import { ModalEnviarPedidos, } from "./components/ModalEnviarPedido";
import { getSelectionCell, TypedTable } from "../../../components/TypedTable";
import { HorizontalTabs } from "../../../components/Tabs";
import { useEffect, useMemo, useState } from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { useNavigate } from "react-router";
import { createColumnHelper } from "@tanstack/react-table";
import { useDisclosure, useDisclosureData } from "../../../hooks/UseDisclosure";
import { ModalConfirmarEliminar } from "./components/ModalConfirmarEliminar";
import { Loading, QueryError } from "../../../components/Loading/Loading";

export function LanzarCiclosPage() {
	const [filtroMedio, setFiltroMedio] = useState("");
	const [filtroEmpaquetado, setFiltroEmpaquetado] = useState("");
	const [filtroEnviado, setFiltroEnviado] = useState("");

	return (
		<div id="content" className="content" >
			<title>Almacen | Lanzamiento de ciclos</title>

			<Breadcrumb
				sectionTitle="Pedidos Venta"
				links={[
					{ label: "Pedidos Venta", active: true }
				]}
			/>


			<div className="box-shadow panel-box panel-info" style={{ display: "none" }}>
				<h4><strong>Info</strong></h4>
				Listado de ciclos de pedidos de venta que se gestiona administración. Existe un panel de filtros donde poder filtrar los ciclos según los diferentes criterios.
				Desde la siguiente pantalla se gestiona el lanzamiento de ciclos, asi como la post-gestión de ver si estan los pedidos empaquetados y marcar los albaranes como enviados
			</div>


			<Disclosure style={{ marginBottom: 20 }}>
				{/* First element is the summary, second is the content */}
				<h4 className="panel-title panel-heading senalar">
					Filtro
				</h4>
				<AcordeonFiltros
					filtroMedio={filtroMedio}
					setFMedio={setFiltroMedio}
					filtroEmpaquetado={filtroEmpaquetado}
					setFEmpaquetado={setFiltroEmpaquetado}
					filtroEnviado={filtroEnviado}
					setFEnviado={setFiltroEnviado}
				/>
			</Disclosure>

			<TablaConTabs
				filtroMedio={filtroMedio}
				filtroEmpaquetado={filtroEmpaquetado}
				filtroEnviado={filtroEnviado}
			/>


			{/* <ModalPedidoEmpaquetado /> */}
		</div>
	);
}


interface PropsAcordeonFiltros {
	readonly filtroMedio: string;
	readonly setFMedio: (value: string) => void;
	readonly filtroEmpaquetado: string;
	readonly setFEmpaquetado: (value: string) => void;
	readonly filtroEnviado: string;
	readonly setFEnviado: (value: string) => void;
}
function AcordeonFiltros(props: PropsAcordeonFiltros) {
	const { data: medios, isLoading, isError } = UseMedios();

	if (isLoading) return <div>Cargando...</div>;
	if (isError) return <div>Error al cargar los transportistas</div>;

	return (
		<div className="inputContainerGrid" style={{ padding: 30 }} role="tabpanel">
			<div className="containerLbl">
				<label style={{ fontSize: 17 }}>Transportistas: </label>
				<select className="form-control" value={props.filtroMedio} onChange={e => props.setFMedio(e.target.value)}>
					<option value="" >Sin Filtrar</option>
					{medios?.map(linea => (
						<option value={linea.idMedio} key={linea.idMedio}>
							{linea.idMedio} - {linea.nombreMedio}
						</option>
					))}
				</select>
			</div>
			<div className="containerLbl">
				<label style={{ fontSize: 17 }}>Empaquetado: </label>
				<select className="form-control" value={props.filtroEmpaquetado} onChange={e => props.setFEmpaquetado(e.target.value)}>
					<option value="" >Sin Filtrar</option>
					<option value="true">Empaquetado</option>
					<option value="false">No empaquetado</option>
				</select>
			</div>
			<div className="containerLbl" style={{ display: "none" }}>
				<label style={{ fontSize: 17 }}>Enviado: </label>
				<select className="form-control" value={props.filtroEnviado} onChange={e => props.setFEnviado(e.target.value)}>
					<option value="" >Sin Filtrar</option>
					<option value="true">Enviado</option>
					<option value="false">No enviado</option>
				</select>
			</div>
		</div>
	);
}


interface PropsTablaConTabs {
	readonly filtroMedio: string;
	readonly filtroEmpaquetado: string;
	readonly filtroEnviado: string;
}
function TablaConTabs(props: PropsTablaConTabs) {
	const [cicloVisualizado, setCicloVisualizado] = useState("null");
	const { data: ciclos, error, isPending } = UseCiclos();


	if (error) return <QueryError error={error} fallback="Error al cargar los ciclos" />;
	if (isPending) return <Loading />;

	const ciclosMapped = Object.entries(ciclos.data).map(([idCiclo, ciclo]) => {
		const tituloCiclo = ciclo.idCiclo != null ? `Ciclo ${idCiclo} - Prioridad: ${Prioridades[ciclo.prioridad]}` : "Sin Ciclo";
		return [tituloCiclo, idCiclo] as [string, string];
	});

	// eslint-disable-next-line @typescript-eslint/dot-notation -- For "null" it doesnt
	const ciclo = cicloVisualizado === "null" ? ciclos.data["null"] : ciclos.data[Number(cicloVisualizado)];
	const pedidosFiltrados = ciclo.pedidos
		.filter(p => (props.filtroMedio === "" || p.idTransporte.toString() === props.filtroMedio))
		.filter(p => (props.filtroEmpaquetado === "" || p.empaquetado.toString() === props.filtroEmpaquetado))
		.filter(p => (props.filtroEnviado === "" || p.enviado.toString() === props.filtroEnviado));



	return (
		<div className="tabsCiclos">
			{Constantes.existenCiclos ? (
				<HorizontalTabs options={ciclosMapped} value={cicloVisualizado} setValue={setCicloVisualizado} />
			) : null}

			<div className="">
				<div className="table-responsive">
					<TablaPedidos data={pedidosFiltrados} cicloActual={ciclo} />
				</div>
			</div>


		</div>
	);
}


function TablaPedidos(props: { readonly data: PedidoVenta[]; readonly cicloActual: CicloVenta; }) {
	const disclosureInfo = useDisclosureData(0);
	const disclosureRevertir = useDisclosure();
	const disclosureLanzar = useDisclosure();
	const disclosureMarcarEnviados = useDisclosure();
	const [pedidosMarcados, setPedidosMarcados] = useState<Record<string, boolean>>({});

	const navigate = useNavigate();

	const openInfo = disclosureInfo.open;

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<PedidoVenta>();
		const formatter = new Intl.DateTimeFormat("es-ES");


		function getBotonesPedido(pedido: PedidoVenta) {
			const iconEmpaquetado = (pedido.empaquetado ? "package-open.svg" : "package-open.svg");

			const onClickInfo = () => openInfo(pedido.idPedido);
			const onClickEmpaquetado = () => {
				const params = new URLSearchParams({
					"idPedido": String(pedido.idPedido),
				});

				void navigate("/empaquetado?" + params.toString());
			};

			return (
				<div className='containerIconoPedido'>
					<button type="button" className="btnIcon" onClick={onClickInfo}>
						<img className="square35" src="/img/icons/info.svg" />
					</button>
					<button type="button" className="btnIcon" onClick={onClickEmpaquetado}>
						<img className="square35" src={"/img/icons/" + iconEmpaquetado} />
					</button>
				</div>
			);
		}

		return [
			getSelectionCell(columnHelper),

			columnHelper.accessor("fechaPedido", { header: "Fecha Pedido", cell: info => formatter.format(info.getValue() * 1000) }),
			columnHelper.display({ id: "medio", header: "Medio", cell: info => `${info.row.original.idTransporte} - ${info.row.original.nombreTransporte}`, }),
			columnHelper.display({ id: "cliente", header: "Cliente", cell: info => `${info.row.original.idCliente} - ${info.row.original.nombreCliente}`, }),
			columnHelper.accessor("idPedido", { header: "ID Pedido" }),
			// columnHelper.accessor('peso_total', { header: 'Peso' }),
			columnHelper.accessor("importe", { header: "Importe", cell: info => `${info.getValue()}€` }),
			columnHelper.display({ id: "acciones", header: "", cell: info => getBotonesPedido(info.row.original) }),	//, meta: { className: "p-0 h-full" }
		];
	}, [navigate, openInfo]);



	// Reset selected rows when data changes
	useEffect(() => {
		setPedidosMarcados({});
	}, [props.data]);

	return <>
		<TypedTable
			className="dataTable display"
			data={props.data}
			columns={columns}

			getRowId={row => row.idPedido.toString()}
			selection={pedidosMarcados}
			setSelection={setPedidosMarcados}
		/>
		<div style={{ display: "flex", justifyContent: "space-evenly", padding: "10px 0" }}>
			{props.cicloActual.idCiclo == null && Constantes.existenCiclos ? (
				<button className="btnPrimary" onClick={disclosureLanzar.open} type="button">
					Asignar a ciclo
				</button>
			) : null}
			{props.cicloActual.idCiclo != null && Constantes.existenCiclos ? (
				<button className="btnPrimary" onClick={disclosureRevertir.open} type="button">
					Retirar de ciclo
				</button>
			) : null}

			<button className="btnPrimary" onClick={disclosureMarcarEnviados.open} type="button">
				Marcar como enviados
			</button>
		</div>

		<ModalInformacionPedido
			show={disclosureInfo.isOpen}
			idPedido={disclosureInfo.data}
			close={disclosureInfo.close}
		/>

		{props.cicloActual.idCiclo == null && (
			<ModalConfirmarLanzar
				show={disclosureLanzar.isOpen}
				close={disclosureLanzar.close}
				pedidosMarcados={pedidosMarcados}
			/>
		)}
		{props.cicloActual.idCiclo != null && (
			<ModalConfirmarEliminar
				show={disclosureRevertir.isOpen}
				close={disclosureRevertir.close}
				pedidosMarcados={pedidosMarcados}
				idCiclo={props.cicloActual.idCiclo}
			/>
		)}
		<ModalEnviarPedidos
			show={disclosureMarcarEnviados.isOpen}
			close={disclosureMarcarEnviados.close}
			pedidosMarcados={pedidosMarcados}
		/>
	</>;
}

function UseCiclos() {
	return useQuery({
		queryKey: ["getCiclos"],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<{ data: Record<string, CicloVenta>; }>("GET", "/getCiclosConPedidos");
		},
	});
}




enum Prioridades {
	"Tiempo Real" = 1,
	"Alta" = 2,
	"Normal" = 3,
	"Menor" = 4,
	"Baja" = 5,
}


function UseMedios() {
	return useQuery({
		queryKey: ["getMedios"],
		queryFn: () => ComunicacionAjax.sendAjaxRequest<Medio[]>("GET", "/getMedios"),
	});
}




interface Medio {
	idMedio: string,
	nombreMedio: string,
}
interface CicloVenta {
	idCiclo: number | null;
	prioridad: number;
	pedidos: PedidoVenta[];
}
interface PedidoVenta {
	idTransporte: number;
	nombreTransporte: string;
	idCliente: number;
	nombreCliente: string;
	idPedido: number;
	importe: number;
	// peso_total: number;
	fechaPedido: number;
	empaquetado: boolean;
	enviado: boolean;
}